import React, { useEffect } from 'react';
import { isMobile } from "react-device-detect";
import MobileMiddleScreen from './MobileAuthentication/MobileMiddleScreen';
import Authentication from './Authentication/Authentication'
import MiddleScreenInZalo from './MobileZaloOnly/MiddleScreenInZalo';
import { checkUserAgent } from './CommonFunction'
import MiddleScreenInZaloPay from "./MobileZaloPayOnly/MiddleScreenInZaloPay";
const HomeScreen = () => {
  useEffect(() => {
    document.title = 'Liên kết Zalopay';
  }, []);

  const renderContent = () => {
    let content = '';
    let isZPI = checkUserAgent(' Zalo ') && !checkUserAgent('ZaloPayClient');
    let isZPA = !checkUserAgent(' Zalo ') && checkUserAgent('ZaloPayClient');
    if (isMobile) {
      content = <MobileMiddleScreen/>
      if(isZPI){
        content = <MiddleScreenInZalo />
      }
      if(isZPA){
        content = <MiddleScreenInZaloPay />
      }
    }
    else {
      content = <Authentication />
    }
    
    return content;
  }

  let renderComponent = renderContent();
  return (
    renderComponent
  )
};

export default HomeScreen;
